module.exports = __webpack_public_path__ + "img/Education_Recall_3_Set.d8504677.png";